<p-sidebar [visible]="true"
           [position]="'right'"
           [baseZIndex]="10000"
           [modal]="true"
           (onHide)="handleSideBarHide()"
           [style]="{width:'700px'}">

    <ng-template pTemplate="header">{{productId ? 'Edit Product' : 'Add Product'}}</ng-template>

    <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

    <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 260px)'}"
                   [styleClass]="'app-scrollpanel'">
        <div *ngIf="activeTab===editProductTab.ProductInfo" style="padding: 10px">
            <div class="field">
                <div>Image</div>

                <div style="margin-right: 10px">
                    <a href="{{product.ImageUrl}}" target="_blank">
                        <img style="max-width: 260px" src="{{product.ImageUrl}}" />
                    </a>
                </div>
                <div>
                    <input id="idImgInput"
                           type="file"
                           accept="image/*"
                           style="display: none"
                           (change)="handleImageChange($event)" />

                    <button pButton
                            type="button"
                            label="Upload"
                            class="edit-food-prod-btn"
                            icon="pi pi-upload"
                            (click)="handleUploadClick()"></button>
                </div>
            </div>

            <div class="field">
                <div>Restaurant</div>
                <p-dropdown [options]="restaurants"
                            [(ngModel)]="product.RestaurantId"
                            [optionLabel]="'Name'"
                            [optionValue]="'Id'"
                            [filter]="true"
                            [filterBy]="'Name'"
                            [style]="{width:'100%'}"
                            placeholder="Select Restaurant"
                            [disabled]="productId !== 0 || product.RestaurantId"
                            [showClear]="false">
                </p-dropdown>
            </div>
            <div class="field">
                <div>Name</div>
                <input pInputText class="edit-food-prod-field" [(ngModel)]="product.Name" />
            </div>
            <div class="field">
                <div>Description</div>
                <input pInputText class="edit-food-prod-field" [(ngModel)]="product.Description" />
            </div>
            <div class="field">
                <div>Plu</div>
                <input pInputText class="edit-food-prod-field" [(ngModel)]="product.Plu" />
            </div>
            <div class="field">
                <p-checkbox [(ngModel)]="isEnabled"
                            [binary]="true"
                            [label]="'Enabled'"></p-checkbox>
            </div>
            <div class="field">
                <div>BasePrice</div>
                <p-inputNumber [(ngModel)]="product.BasePrice"></p-inputNumber>
            </div>
            <div class="field">
                <div>DeliveryTax</div>
                <p-inputNumber [(ngModel)]="product.DeliveryTax"></p-inputNumber>
            </div>
            <div class="field">
                <div>TakeawayTax</div>
                <p-inputNumber [(ngModel)]="product.TakeawayTax"></p-inputNumber>
            </div>
            <div class="field">
                <div>DineInTax</div>
                <p-inputNumber [(ngModel)]="product.DineInTax"></p-inputNumber>
            </div>
        </div>

        <div *ngIf="activeTab===editProductTab.ModifierGroups && !product.RestaurantId"
             style="padding: 10px; color: red">
            Please select restaurant
        </div>
        <div *ngIf="activeTab===editProductTab.ModifierGroups && product.RestaurantId"
             style="padding: 10px">
            <p-dropdown [options]="freeModifierGroups"
                        [optionLabel]="'Name'"
                        [optionValue]="'Id'"
                        [filter]="true"
                        [filterBy]="'Name'"
                        [style]="{width:'100%'}"
                        placeholder="Add Modifier Group"
                        (onChange)="handleModifierGroupSelected($event)"
                        [showClear]="true">
            </p-dropdown>

            <div style="height: 20px"></div>

            <p-table [columns]="modifierGroupCols"
                     [value]="productModifierGroups"
                     [resizableColumns]="true"
                     [columnResizeMode]="'expand'"
                     [autoLayout]="true"
                     [styleClass]="'p-datatable-striped'"
                     [scrollable]="true"
                     [scrollHeight]="'flex'">
                <ng-template pTemplate="header">
                    <tr>
                        <th [pSortableColumn]="'Id'" pResizableColumn>Id <p-sortIcon field="Id"></p-sortIcon></th>
                        <th [pSortableColumn]="'Name'" pResizableColumn>Name <p-sortIcon field="Name"></p-sortIcon></th>
                        <th>Action</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-modifierGroup>
                    <tr>
                        <td class="ui-resizable-column">{{modifierGroup.Id}}</td>
                        <td class="ui-resizable-column">{{modifierGroup.Name}}</td>
                        <td>
                            <span class="action-icon-svg" (click)="handleDeleteModifierGroupClick(modifierGroup)">
                                <img src="../Content/xpress-app/images/svg/icon_cancel_yellow.svg" />
                            </span>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div *ngIf="activeTab===editProductTab.Categories"
             style="padding: 10px">
            <p-dropdown [options]="freeCategories"
                        [optionLabel]="'Name'"
                        [optionValue]="'Id'"
                        [filter]="true"
                        [filterBy]="'Name'"
                        [style]="{width:'100%'}"
                        placeholder="Add Category"
                        (onChange)="handleCategorySelected($event)"
                        [showClear]="true">
            </p-dropdown>

            <div style="height: 20px"></div>

            <p-table [columns]="categoriesCols"
                     [value]="productCategories"
                     [resizableColumns]="true"
                     [columnResizeMode]="'expand'"
                     [autoLayout]="true"
                     [styleClass]="'p-datatable-striped'"
                     [scrollable]="true"
                     [scrollHeight]="'flex'">
                <ng-template pTemplate="header">
                    <tr>
                        <th [pSortableColumn]="'Id'" pResizableColumn>Id <p-sortIcon field="Id"></p-sortIcon></th>
                        <th [pSortableColumn]="'Name'" pResizableColumn>Name <p-sortIcon field="Name"></p-sortIcon></th>
                        <th>Action</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-category>
                    <tr>
                        <td class="ui-resizable-column">{{category.Id}}</td>
                        <td class="ui-resizable-column">{{category.Name}}</td>
                        <td>
                            <span class="action-icon-svg" (click)="handleDeleteCategoryClick(category)">
                                <img src="../Content/xpress-app/images/svg/icon_cancel_yellow.svg" />
                            </span>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-scrollPanel>

    <hr style="margin-left: -1rem; margin-right: -1rem;" />

    <div class="flex-row" style="padding-left: 10px; padding-right: 10px">
        <div>
            <button pButton
                    type="button"
                    label="Cancel"
                    class="p-button-danger"
                    (click)="handleSideBarHide()"></button>
        </div>

        <div class="filler"></div>

        <div>
            <button pButton
                    type="button"
                    label="{{product ? 'Save' : 'Create'}}"
                    class="edit-food-prod-btn"
                    (click)="handleSaveClick()"></button>
        </div>
    </div>
</p-sidebar>

<p-toast position="top-right"></p-toast>
